import React, { useState, useRef } from "react";
import "./LoginPage.css";
import { API_BASE_URL } from "./api";
import ReCAPTCHA from "react-google-recaptcha";

export default function AdminLoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);

  // Sem sitekey configurada o widget lanca e derruba a pagina inteira.
  // Nesse caso o captcha e omitido (o backend tambem roda com RECAPTCHA_ENABLED=0).
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  async function doLogin(usernameValue, passwordValue) {
    if (siteKey && !captchaToken) throw new Error("Confirme o reCAPTCHA para continuar.");

    const res = await fetch(`${API_BASE_URL}/auth/token/`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: usernameValue,
        password: passwordValue,
        recaptcha_token: captchaToken,
      }),
    });

    if (!res.ok) {
      let msg = "Usuário ou senha inválidos.";
      try { const d = await res.json(); if (d.detail) msg = d.detail; } catch {}
      throw new Error(msg);
    }

    const meRes = await fetch(`${API_BASE_URL}/auth/me/`, { credentials: "include" });
    if (!meRes.ok) throw new Error("Erro ao carregar perfil.");
    onLogin(await meRes.json());
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setErro(null);
    setLoading(true);
    try {
      await doLogin(username, senha);
    } catch (err) {
      setErro(err.message || "Erro ao autenticar.");
      if (String(err?.message || "").toLowerCase().includes("recaptcha")) {
        captchaRef.current?.reset?.();
        setCaptchaToken(null);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lp-bg">
      {/* Efeitos de fundo */}
      <div className="lp-bg-orb lp-bg-orb-1" />
      <div className="lp-bg-orb lp-bg-orb-2" />
      <div className="lp-bg-orb lp-bg-orb-3" />

      {/* Card principal */}
      <div className="lp-card-wrap">
        <div className="lp-card">

          {/* ── LADO ESQUERDO: logo + boas-vindas ── */}
          <div className="lp-panel-left">
            <div className="lp-panel-left-inner">
              <img
                src={`${process.env.PUBLIC_URL}/Logo-dark.png`}
                alt="DadosPJ"
                className="lp-logo"
              />
              <div className="lp-divider" />
              <h2 className="lp-welcome-title">Acesso administrativo</h2>
              <p className="lp-welcome-sub">
                Área restrita à equipe DadosPJ.
              </p>
            </div>
          </div>

          {/* ── DIVISOR ── */}
          <div className="lp-separator" />

          {/* ── LADO DIREITO: formulário ── */}
          <div className="lp-panel-right">
            <form className="lp-form" onSubmit={handleSubmit} noValidate>

              <div className="lp-form-header">
                <h3>Acesso administrativo</h3>
                <p>Entre com usuário e senha da equipe.</p>
              </div>

              {erro && <div className="lp-error">{erro}</div>}

              <div className="lp-field">
                <label htmlFor="lp-email">E-mail</label>
                <input
                  id="lp-email"
                  type="email"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="nome@empresa.com"
                  required
                  autoComplete="email"
                />
              </div>

              <div className="lp-field">
                <div className="lp-field-row">
                  <label htmlFor="lp-senha">Senha</label>
                </div>
                <input
                  id="lp-senha"
                  type="password"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
              </div>

              {siteKey && (
                <div className="lp-captcha-wrap">
                  <ReCAPTCHA
                    ref={captchaRef}
                    sitekey={siteKey}
                    onChange={(token) => setCaptchaToken(token)}
                    onExpired={() => setCaptchaToken(null)}
                    theme="dark"
                  />
                </div>
              )}

              <button className="lp-btn" type="submit" disabled={loading}>
                {loading ? "Entrando..." : "Entrar"}
              </button>

            </form>
          </div>

        </div>
      </div>
    </div>
  );
}
